import { Location } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UiKitModule } from "@app/ui-kit.module";
import type { ScopedProject } from "@domain/project/project-guards";
import { FloorplanMenuType } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-type";

@Component({
  selector: "app-configuration-wizard-back-button",
  templateUrl: "./configuration-wizard-back-button.component.html",
  styleUrl: "./configuration-wizard-back-button.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class ConfigurationWizardBackButtonComponent {
  private router = inject(Router);
  private location = inject(Location);
  private activatedRoute = inject(ActivatedRoute);

  @Input({ required: true }) project!: ScopedProject;
  @Input({ required: true }) floorplanGroup!: FloorplanMenuType;
  @Output() clicked = new EventEmitter<any>();

  navigateBack() {
    const floorplanId = this.activatedRoute.snapshot.queryParams["floorplan_id"];
    const groupId = this.activatedRoute.snapshot.queryParams["group_id"];

    if (groupId) {
      this.clicked.emit();
    } else if (floorplanId) {
      this.router.navigate(["/projects", this.project.id, "floorplans", floorplanId], {
        queryParams: {
          selectedGroup: this.floorplanGroup,
        },
      });
    } else {
      this.location.back();
    }
  }
}
